module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.eventUid) ? _c('v-card', {
    staticClass: "elevation-5"
  }, [_c('v-card-text', [(_vm.confirmed) ? _c('div', {
    staticClass: "body-1 card-title-text"
  }, [_vm._v("\n            Ваш email адрес подтвержден! Для продолжения нажмите \"Далее\" или зайдите в нужный сервис\n          ")]) : _c('div', {
    staticClass: "body-1 card-title-text"
  }, [_vm._v("\n            Проверка ...\n          ")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "disabled": !_vm.confirmed
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$router.push('/')
      }
    }
  }, [_vm._v("Далее")])], 1)], 1) : _c('v-card', {
    staticClass: "elevation-5"
  }, [_c('v-card-text', [(_vm.sent) ? _c('div', {
    staticClass: "body-1 card-title-text"
  }, [_vm._v("Письмо со ссылкой для подтверждения отправлено на адрес "), _c('b', [_vm._v(_vm._s(_vm.sentEmail))]), _vm._v(". Для продолжения проверьте Ваш почтовый ящик и перейдите по ссылке, указанной в письме."), _c('br'), _vm._v("Для повторной отправки введите Ваш электронный адрес и нажмите \"Отправить\" снова.\n          ")]) : _c('div', {
    staticClass: "body-1 card-title-text"
  }, [_vm._v("Для продолжения необходимо подтвердить адрес электронной почты. Введите Ваш адрес электронной почты и нажмите \"Отправить\" чтобы отправить письмо с ссылкой для подтверждения")]), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "id": "form"
    },
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('v-text-field', {
    ref: "email",
    attrs: {
      "prepend-icon": "mdi-email-outline",
      "name": "mail",
      "label": "E-mail",
      "type": "email",
      "rules": [_vm.rules.required, _vm.rules.email]
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "disabled": _vm.sentButtonDisabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sendEmailValidationMessage()
      }
    }
  }, [_vm._v("Отправить\n            "), (_vm.sentTimeout) ? _c('span', [_vm._v(" (" + _vm._s(_vm.sentTimeout) + ")")]) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin-top": "14px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "6px"
    }
  }, [_vm._v("Другая учетная запись?")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$router.push('/login')
      }
    }
  }, [_vm._v("Войти")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-674dedbc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./webapp/components/EmailValidate.vue
// module id = 483
// module chunks = 0